import type { I18nFn } from '#/i18n/types/I18nFn';

export const SearchGroupRefinement = {
  LOCATION_TYPE: 'locationType',
  LOCALE: 'locale',
  RADIUS: 'radius',
} as const;

export const SEARCH_GROUPS_REFINEMENT_NAMES = Object.values(
  SearchGroupRefinement,
);

export type SearchGroupsRefinementType =
  (typeof SearchGroupRefinement)[keyof typeof SearchGroupRefinement];

export function SEARCH_GROUPS_REFINEMENT_LABELS(i18n: I18nFn) {
  return {
    [SearchGroupRefinement.LOCATION_TYPE]: i18n('Location Type'),
    [SearchGroupRefinement.LOCALE]: i18n('Listing Language'),
    [SearchGroupRefinement.RADIUS]: i18n('Radius'),
  } as Record<SearchGroupsRefinementType, string>;
}
